import { render, staticRenderFns } from "./FeedbackInquiry.vue?vue&type=template&id=bbaac34a&scoped=true"
import script from "./FeedbackInquiry.vue?vue&type=script&lang=js"
export * from "./FeedbackInquiry.vue?vue&type=script&lang=js"
import style0 from "./FeedbackInquiry.vue?vue&type=style&index=0&id=bbaac34a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbaac34a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbaac34a')) {
      api.createRecord('bbaac34a', component.options)
    } else {
      api.reload('bbaac34a', component.options)
    }
    module.hot.accept("./FeedbackInquiry.vue?vue&type=template&id=bbaac34a&scoped=true", function () {
      api.rerender('bbaac34a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/back/MeetingRoom/FeedbackInquiry.vue"
export default component.exports